import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import { CORE_ROUTE } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { isLocalStorageSupported } from "@obg/ngx.global";
import { RouteAction } from "@obg/ngx.router";

import { LOGIN_FORTY_DAYS_REVIEW_ALERT_ID } from "./login-forty-days-review-dialog.const";

@Component({
	selector: "obg-m-login-forty-days-review-dialog",
	templateUrl: "./login-forty-days-review-dialog.component.html",
	styleUrls: ["./login-forty-days-review-dialog.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LoginFortyDaysReviewDialogComponent {
	@HostBinding("class.obg-m-login-forty-days-review-dialog") hostClass = true;

	constructor(
		private store: Store<CommonState & CoreContentState>,
		private dialogRef: MatDialogRef<LoginFortyDaysReviewDialogComponent>
	) {
		if (isLocalStorageSupported()) {
			localStorage.setItem(LOGIN_FORTY_DAYS_REVIEW_ALERT_ID, "1");
		}
	}

	onVerifyIdentityClick(): void {
		this.store.dispatch(RouteAction.navigate(CORE_ROUTE.verification.root));
		if (isLocalStorageSupported()) {
			localStorage.removeItem(LOGIN_FORTY_DAYS_REVIEW_ALERT_ID);
		}
		this.onContinueClick();
	}

	onContinueClick() {
		if (isLocalStorageSupported()) {
			localStorage.removeItem(LOGIN_FORTY_DAYS_REVIEW_ALERT_ID);
		}
		this.dialogRef.close();
	}
}
